/* c-ugc.js — the add to cart a UGC card does beyond render: the product bar
   posts to /cart/add and hands the response to Dawn's cart drawer, so the card
   adds without leaving the page.

     <form data-ugc-cart> <input name="id"> <button type="submit"> </form>

   The video swap lives in c-video.js, which the section loads alongside this. */
(function () {
  'use strict';

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ugc-cart]');
    if (!form || !window.routes || !window.routes.cart_add_url) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    if (button && button.getAttribute('aria-disabled') === 'true') return;
    if (button) button.setAttribute('aria-disabled', 'true');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          // Sold out or otherwise rejected — fall back to the product page.
          if (form.dataset.ugcProductUrl) window.location = form.dataset.ugcProductUrl;
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          // renderContents clears is-empty on .drawer__inner but not on
          // <cart-drawer> itself, and open() then looks for .drawer__inner-empty
          // which the re-render has just removed — trapFocus(null) throws.
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function () {
        if (form.dataset.ugcProductUrl) window.location = form.dataset.ugcProductUrl;
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-disabled');
      });
  });
})();
